<template>
    <v-card hover raised class="text-xs-center">
        <v-card-title primary-title>
            <h3 class="headline mb-0">Ir a Presupuesto</h3>
            <v-spacer></v-spacer>
            <slot name="opciones"></slot>
        </v-card-title>
        <form @submit.prevent="presupuestoIr()">
            <v-card-text>
                <v-text-field label="Ingrese el número" v-model="presupuesto_id"></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn type="submit" flat color="orange">Abrir</v-btn>
            </v-card-actions>
        </form>
    </v-card>
</template>

<script>
    export default {
        name: "presupuestoIr",
        data() {
            return {
                presupuesto_id: ''
            }
        },
        methods: {
            presupuestoIr() {
                this.$router.push('/presupuesto/' + this.presupuesto_id);
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/dashboard/presupuestoIr.vue